import Section from "../../section/Section";
import useBotOnButton from "../../../../../src/_hooks/useBotOnButton";

export default function ContactUs() {
	const { trigger } = useBotOnButton("get-in-touch");
	return (
		<Section className="py-4 py-md-12 border-bottom border-dark">
			<span className="contact-us-text">How can we help?</span>{" "}
			<span className="contact-us-text contact-us-btn cursor-pointer" onClick={() => trigger()}>
				Contact us
			</span>
		</Section>
	);
}
